import { AdminMessage, APPS } from '~/models/admin';
import { ApiResponse, api } from './api.service';
import getRuntimeConfig from './runtime-config.service';

const getAdminMessage = async (): Promise<ApiResponse<AdminMessage[]>> => {
    const adminUrl = process.env.CXP_ADMIN_ENDPOINT || '';
    const runtimeConfig = await getRuntimeConfig();
    const apiKey = runtimeConfig.adminAPIKey;

    const response = api.get<AdminMessage[]>(
        'ADMIN',
        adminUrl,
        {
            params: {
                apps: APPS,
            },
            paramsSerializer: params =>
                Object.entries(params)
                    .flatMap(([key, value]) =>
                        Array.isArray(value) ? value.map(v => `${key}=${v}`) : `${key}=${value}`
                    )
                    .join('&'),
        },
        {
            'X-API-Key': apiKey,
            'Content-Type': 'application/json',
        }
    );

    // following code to generate test data:
    // const result: ApiResponse<AdminMessage> = {
    //     data: {
    //         messageContent: 'this is a maintenance example',
    //         messageType: 'maintain',
    //         messageContentFrench: 'FR - this is a maintenance example',
    //         isActive: true,
    //         fromTime: '2024-02-13T00:00:00',
    //         toTime: '2024-02-13T00:00:00',
    //     },
    //     statusCode: 200,
    //     message: '',
    //     errorCodes: [],
    // };
    // return Promise.resolve(result);

    return response;
};

const adminService = {
    getAdminMessages: getAdminMessage,
};

export default adminService;
